// extracted by mini-css-extract-plugin
export default {"cardContainer":"CardSlide_cardContainer__XufEm","card":"CardSlide_card__idRPC"};